import React, { useEffect, useState } from "react";
import { makeStyles, Typography, Grid, Button, Box } from "@material-ui/core/";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getApplicationProfileData,
  postprofileData,
} from "../../../../reduxSlices/profileSlice";
import localizedStrings from "../../../../utils/localize";
import SnackBar from "../../../SnackBar";
import { getApplicantStatus } from "../../../../reduxSlices/applicationSlice";

const useStyle = makeStyles((theme) => ({
  container: {
    padding: "1rem 0",
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginBottom: "-9px !important",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  profileFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      marginBottom: "1rem",
      width: "100%",
    },
  },
  buttonGroup: {
    display: "flex",
    gap: "0.5rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "0.5rem",
    },
  },
  mobileButton: {
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0 !important",
    },
  },
}));

const TopItems = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const profileDataEdit = useSelector(
    (state) => state.profileData.profileDataEdit,
  );

  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );

  const [disabledValue, setDisabledValue] = useState(true);
  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });

  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
    );
  }, [dispatch]);

  useEffect(() => {
    const countryId = profileDataEdit?._ses_countryofresidence_value;
    const isUSorCanada =
      countryId === "01f93658-1116-ee11-9cbe-000d3af4f17d" ||
      countryId === "c3f83658-1116-ee11-9cbe-000d3af4f17d";

    const requiredStateOrProvince =
      !isUSorCanada ||
      (profileDataEdit?.ses_stateorprovince !== null &&
        profileDataEdit?.ses_stateorprovince !== "");

    const requiredPostalCode =
      !isUSorCanada ||
      (profileDataEdit?.address1_postalcode !== null &&
        profileDataEdit?.address1_postalcode !== "");

    if (
      profileDataEdit?.address1_line1 === null ||
      profileDataEdit?.address1_line1 === "" ||
      profileDataEdit?.address1_city === null ||
      profileDataEdit?.address1_city === "" ||
      !requiredStateOrProvince ||
      !requiredPostalCode
    ) {
      setDisabledValue(true);
    } else {
      setDisabledValue(false);
    }
  }, [profileDataEdit]);

  const handleSave = () => {
    let updatedProfileData = { ...profileDataEdit };
    updatedProfileData = {
      ...profileDataEdit,
    };

    dispatch(
      postprofileData({
        ...updatedProfileData,
        contactid: window.localStorage.getItem("x-auth-contactId"),
      }),
    );
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const handleClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
  };
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  return (
    <>
      <Grid className={classes.container} style={{ marginBotton: "-9px" }}>
        <SnackBar
          open={showSnackBar.status}
          message={showSnackBar.message}
          handleClose={handleClose}
        />
        <Typography component="div" className={classes.profileFont}>
          {localizedStrings.students.profile.heading}
        </Typography>

        <Box className={classes.buttonGroup}>
          <Button
            variant="contained"
            color="primary"
            disabled={disabledValue}
            onClick={handleSave}
            className={classes.mobileButton}
          >
            {localizedStrings.students.profile.save}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            style={{ marginLeft: "0.5rem" }}
            onClick={() =>
              dispatch(
                getApplicationProfileData(
                  applicantStatus?.ses_applicantstatus.ses_applicantid,
                ),
              )
            }
            className={classes.mobileButton}
          >
            {localizedStrings.students.profile.refresh}
          </Button>
          <Link to="/prospective/landingpage">
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: "0.5rem" }}
              className={classes.mobileButton}
            >
              {localizedStrings.students.profile.back}
            </Button>
          </Link>
        </Box>
      </Grid>
      <Typography style={{ marginBottom: "21px" }}>
        Les champs marqués d’un astérisque (*) doivent être remplis avant que
        les données de la page puissent être enregistrées.
      </Typography>
    </>
  );
};

export default TopItems;
